/**
 * Serves as the base validator for all other validators that have multiple fields.
 *
 */
import Backbone from 'backbone';

import Validator from 'utils/validators/Validator';

var MultiFieldValidator = Validator.extend({
    initialize: function(args) {
        this.initializeMultifieldValidator(args);
    },

    /**
     * Parent class specific initialization function used to get around limitations of inheritance
     * in javascript.
     *
     * @param args
     *      elements: array of elements that need to be validated as one unit.
     */
    initializeMultifieldValidator: function(args) {
        if (!args.elements) {
            throw 'Validator missing elements';
        }

        this.$inputField = jQuery(args.elements);

        this.parser = args.parser; // Parser used to parse the input
        this.formatter = args.formatter; // The formatter object used to format the input
        this.reporter = args.reporter; // The ErrorReporterObject used to display the error.

        var that = this;

        _.each(this.$inputField, function(element) {
            jQuery(element)
                .bind('change', function(evt) {
                    that.onValueChanged(that.getTargetValue());
                })
                .bind('keydown', function(evt) {
                    if (evt.keyCode == 9) {
                        // Tab key
                        that.onValueChanged(that.getTargetValue());
                    } else {
                        that.onInputChanged(that.getTargetValue());
                    }
                });
        });
    },

    /**
     * Needs to be overridden by the deriving validator to combine the multiple fields into a single value.
     * @returns {string}
     */
    getTargetValue: function() {
        return '';
    },

    /**
     * Forces validation on the input field now.  Useful for validating a field when the user hasn't
     * modified it.
     *
     * returns undefined if value passes validation. Return the validation error otherwise.
     */
    validateInputNow: function() {
        return this.onValueChanged(this.getTargetValue());
    }
});

export default MultiFieldValidator;
